const closeModal = (activeModal) => {
  const modal = activeModal;
  const closebtn = modal.querySelector('.closeModal');
  const body = document.querySelector('body');

  const handleClick = (currentTarget, target) => {
    if (currentTarget === target) {
      modal.style.display = 'none';
      body.classList.remove('has-modal');
    }
  };
  modal.addEventListener('click', (event) => {
    handleClick(event.currentTarget, event.target);
  }, true);
  closebtn.addEventListener('click', (event) => {
    handleClick(event.currentTarget, event.target);
  }, true);
};

const showFiguresSliderModal = (slides) => {
  const containerSlides = document.createElement('div');
  containerSlides.classList.add('partners-container');
  slides.forEach((slide) => {
    const clone = slide.cloneNode(true);
    containerSlides.appendChild(clone);
  });
  return containerSlides;
};

const sliderToModalActive = () => {
  const theContent = document.querySelector('.TheContent');
  const sliderToModal = document.querySelector('.sliderToModal');
  const sliderToModalClone = sliderToModal.cloneNode(true);
  const continuosSlider = sliderToModal.querySelector('section.swiper');
  const openSlider = sliderToModal.querySelector('.openSlider');
  const ctaPanel = sliderToModal.querySelector('.cta-panel-contact');
  ctaPanel.style.display = 'none';

  openSlider.addEventListener('click', () => {
    const hasModal = document.querySelector('.TheContent .sliderToModal.active-modal');
    const slides = continuosSlider.querySelectorAll('.swiper-wrapper .swiper-slide:not(.swiper-slide-duplicate) figure');
    const ctaPanelClone = sliderToModalClone.querySelector('.cta-panel-contact');
    const body = document.querySelector('body');

    if (hasModal) {
      hasModal.style.display = 'block';
      body.classList.add('has-modal');
    } else {
      body.classList.add('has-modal');
      const partnersContainer = showFiguresSliderModal(slides);
      const closeModalbtn = document.createElement('button');
      closeModalbtn.innerHTML = 'Fechar <span> + </span>';
      closeModalbtn.classList.add('closeModal');

      sliderToModalClone.firstChild.appendChild(closeModalbtn);
      sliderToModalClone.firstChild.appendChild(partnersContainer);
      sliderToModalClone.firstChild.insertBefore(partnersContainer, ctaPanelClone);
      sliderToModalClone.classList.add('active-modal');

      theContent.appendChild(sliderToModalClone);
    }

    const activeModal = document.querySelector('.sliderToModal.active-modal');
    closeModal(activeModal);
  });
};

document.addEventListener('DOMContentLoaded', sliderToModalActive);
